// extracted by mini-css-extract-plugin
export default {"name":"ClusterManagement_name__tY5KA","domain":"ClusterManagement_domain__zxYBl","actionDisplay":"ClusterManagement_actionDisplay__vErYF"};